<template>
    <div class="boardtype">
        <template v-if="offer.boardType == 'ROOM_ONLY'"></template>
        <template v-if="offer.boardType == 'BREAKFAST'">
            <div class="highlight">Breakfast included</div>
        </template>
        <template v-if="offer.boardType == 'HALF_BOARD'">
            <div class="highlight">Breakfast and dinner included</div>
        </template>
        <template v-if="offer.boardType == 'FULL_BOARD'">
            <div class="highlight">Breakfast, lunch and dinner included</div>
        </template>
        <template v-if="offer.boardType == 'ALL_INCLUSIVE'">
            <div class="highlight">All inclusive</div>
        </template>
        <template v-if="offer.rateCode == 'BED'">
            <div class="highlight">Breakfast included</div>
        </template>
    </div>
</template>

<script>
    export default {
        name: 'BoardType',
        props: {
            offer: {
                type: Object,
                required: true
            },
        }
    }
</script>

<style scoped>
    .highlight{
        color:#066706;
    }
</style>
